import React from 'react';
import BaseTabList from '@material-ui/lab/TabList';

const TabList = (props) => <BaseTabList {...props} />;

export default TabList;
